export const PROJECT_STATUS = {
    PLANNED: 'PLANNED',
    ACTIVE: 'ACTIVE',
    ON_HOLD: 'ON_HOLD',
    COMPLETED: 'COMPLETED',
    ARCHIVED: 'ARCHIVED',
};
export const PROJECT_STATUS_LABELS = {
    PLANNED: 'Planned',
    ACTIVE: 'Active',
    ON_HOLD: 'On hold',
    COMPLETED: 'Completed',
    ARCHIVED: 'Archived',
};
/** Health shown on dashboards; computed from overdue tasks, blockers and critical tickets. */
export const PROJECT_HEALTH = {
    ON_TRACK: 'ON_TRACK',
    AT_RISK: 'AT_RISK',
    DELAYED: 'DELAYED',
};
export const PROJECT_HEALTH_LABELS = {
    ON_TRACK: 'On track',
    AT_RISK: 'At risk',
    DELAYED: 'Delayed',
};
//# sourceMappingURL=project-status.js.map